import { ReactElement, useMemo } from 'react';

// Components.
import { DashboardSection } from '../DashboardSection';

// Styles.
import styles from './DashboardVideoSection.module.scss';

// Types
import { IDashboardVideoSection } from 'store/dashboard/types';

export const DashboardVideoSection = (props: IDashboardVideoSection): ReactElement => {
  const { data = [], label, toggleable } = props;
  const videos = useMemo(() => data.filter((video) => video.source), [data]);

  return (
    <DashboardSection className={styles.section} label={label} toggleable={toggleable}>
      <section className={styles.section}>
        {videos.map((video, index) => (
          <div key={index} className={styles.vimeo}>
            <div className={styles.container}>
              <iframe
                src={video.source}
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                title="How to View Submitted CME Credits for State Licensing Boards"
                allowFullScreen
              />
            </div>
            <script src="https://player.vimeo.com/api/player.js" />
            {video.description && (
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: video.description }} />
            )}
          </div>
        ))}
      </section>
    </DashboardSection>
  );
};
